<script setup>
import { ref, onBeforeMount } from "vue";
import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useMediaStore } from "@/stores/media";

const emit = defineEmits(["refresh"]);
const uiStore = useUiStore();
const mediaStore = useMediaStore();
const companyId = useCompanyStore().companyId;

let selectedIds = ref([]);
let isSubmitted = ref(false);

const onSubmit = () => {
  isSubmitted.value = true;
  let data = {
    companyId: companyId,
    data: {media_ids : selectedIds.value},
  };

  mediaStore
    .bulkDeleteMedia(data)
    .then(() => {
      resetStoreData();
      emit("refresh");
    })
    .catch(() => {
      isSubmitted.value = false;
    });
};

const resetStoreData = () => {
  uiStore.resetModalStore();
};

onBeforeMount(() => {
  if (uiStore.modalData && uiStore.modalAction == "bulk_delete_media") {
    selectedIds.value = uiStore.modalData.ids;
  }
});
</script>
<template>
  <DModal v-if="getModalAction === 'bulk_delete_media'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Bulk Delete Media </template>
    <template #body>
      <div class="delete-text">
        <span
          >Are you sure you want to <b>"Delete"</b> the selected({{
            selectedIds.length
          }}) media ?</span
        >
      </div>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button
            @click="resetStoreData"
            type="button"
            class="btn btn-secondary cancel-button"
          >
            Cancel
          </button>
          <button
            :disabled="isSubmitted"
            @click="onSubmit"
            type="button"
            class="btn btn-danger add-button mr-30"
          >
            Delete
            <span
              v-if="isSubmitted"
              class="spinner-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
